var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.5 17.873c2.587.417 4.5 1.88 4.5 3.627v.75a.75.75 0 0 1-.75.75H7.75a.75.75 0 0 1-.75-.75v-.75c0-1.747 1.913-3.21 4.5-3.627v-.539A2.99 2.99 0 0 1 10 14.75V14a3 3 0 0 1 6 0v.75a2.99 2.99 0 0 1-1.5 2.584zm4-4c2.587.417 4.5 1.88 4.5 3.627v.75a.75.75 0 0 1-.75.75h-3.288c-.68-.75-1.657-1.365-2.846-1.76A3.98 3.98 0 0 0 17 14.75V14c0-1.858-1.28-3.41-3-3.857V10a3 3 0 0 1 6 0v.75a2.99 2.99 0 0 1-1.5 2.584z"
})));
export default SvgGroup;